import * as CookieConsent from "vanilla-cookieconsent";
import StorageStore from "../Storage/storageStore";

class Pixel {

    static facebookPixelId: string | undefined = undefined;
    static ReactPixel: any | undefined = undefined;
    static initialized = false;

    static isAcceptCookies = () => {
        const cookie = CookieConsent.getCookie();
        return cookie && cookie.categories && cookie.categories.includes("marketing");
    }

    static checkInitialized() {
        if (this.initialized) return;
        if (!this.isAcceptCookies()) return;
        if (!this.facebookPixelId) return;
        const ReactPixel = require('react-facebook-pixel');
        const options = {
            autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
            debug: false, // enable logs
        } as any;
        this.ReactPixel = ReactPixel.default;
        this.ReactPixel.init(this.facebookPixelId, {} as any, options);
        this.initialized = true;
    }

    static add(id: string) {
        this.facebookPixelId = id;
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
    }

    static getOrderContents(order: any) {
        return order.items.map((orderDataItem: any) => ({
            id: orderDataItem.id,
            name: orderDataItem.name,
            sku: orderDataItem.item_id,
            price: orderDataItem.total_money.amount,
            currency: orderDataItem.total_money.currency,
            quantity: orderDataItem.quantity
        }));
    }

    static pageView(path: string) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        this.ReactPixel.pageView();
    }

    static addToCart(orderDataItem: any, currency: string) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        this.ReactPixel.track("AddToCart", {
            content_ids: [orderDataItem.item_id],
            content_type: "product",
            value: orderDataItem.total_price,
            currency: currency,
        });
    }

    static removeFromCart(orderDataItem: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        const value = orderDataItem.total_money ? orderDataItem.total_money.amount : undefined;
        this.ReactPixel.track("RemoveFromCart", {
            content_ids: [orderDataItem.item_id],
            content_type: "product",
            value: value,
            currency: orderDataItem.total_money ? orderDataItem.total_money.currency : undefined,
        });
    }

    static viewItem(item: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        const value = item.price ? item.price.amount : undefined;
        this.ReactPixel.track("ViewContent", {
            content_ids: [item.id],
            content_type: "product",
            value: value,
            currency: item.price?.currency ?? "PLN",
        });
    }

    static selectItem(item: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        const value = item.price ? item.price.amount : undefined;
        this.ReactPixel.track("SelectItem", {
            content_ids: [item.id],
            content_type: "product",
            value: value,
            currency: item.price?.currency ?? "PLN",
        });
    }

    static initiateCheckout(cart: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        if (!cart || !cart.items) return;
        this.ReactPixel.track("InitiateCheckout", {
            content_ids: cart.items.map((item: any) => item.item_id),
            content_type: "product",
            num_items: cart.items.length,
            value: cart.total.amount,
            currency: cart.total.currency,
        });
    }

    static purchase(order: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;

        const purchaseData = {
            "transaction_id": order.id,
            "value": order.total_money.amount,
            "currency": order.total_money.currency,
            "tax": 1.23,
            "contents": this.getOrderContents(order),
        };
        this.ReactPixel.track("Purchase", purchaseData);
    }

    static payPurchase(order: any) {
        if (!this.isAcceptCookies()) return;
        this.checkInitialized();
        if (!this.ReactPixel) return;
        const orderId = order.reference_id ? order.reference_id : order.id;
        const isPurchaseAlready = StorageStore.getItem(`pixel_purchase_pay_${orderId}`);
        if (isPurchaseAlready) return;

        const purchaseData = {
            "transaction_id": orderId,
            "value": order.total_money.amount,
            "currency": order.total_money.currency,
            "tax": 1.23,
            "contents": this.getOrderContents(order),
        };
        this.ReactPixel.track("purchase_pay", purchaseData);
        StorageStore.setItem(`pixel_purchase_pay_${orderId}`, "true");
    }

}

export default Pixel;
